import React from 'react'
import MaintenanceSection from '../common/MaintenanceSection/MaintenanceSection.loadable'

export default function Maintenance() {
  return <MaintenanceSection />
}
